<template>
  <div>
    <div v-if="disableForm">
      <div class="custom-search d-flex mb-2">
        <b-button
          v-if="canInsert"
          class="justify-content-start"
          variant="primary"
          @click="inserirHistorico()"
        >
          Alterar Categoria de Contribuição
        </b-button>
      </div>
      <div class="custom-search d-flex justify-content-end mb-2">
        <b-badge
          variant="primary"
          style="font-size: 16px"
        >
          Categoria Atual: {{ faixaAtual }}
        </b-badge>
      </div>
      <b-row>
        <b-col md="12">
          <div class="justify-content-center mb-2">
            <h4>Histórico de Categoria de Contribuição</h4>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
        title="Teste"
        :columns="columns"
        :rows="listaHistorico"
        :rtl="direction"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      />
    </div>
    <div v-else>
      <validation-observer ref="form">
        <b-form @submit.prevent>
          <b-row>
            <!-- dataInicio -->
            <b-col
              cols="12"
              lg="6"
            >
              <validation-provider
                #default="{ errors }"
                name="dataInicio"
                rules="required"
              >
                <b-form-group
                  label="Data de Início"
                  label-for="v-data-inicio"
                >
                  <b-form-input
                    id="v-data-inicio"
                    v-model="FaixaContribuicaoPlace.dataInicio"
                    type="date"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- motivo -->
            <b-col
              cols="12"
              lg="6"
            >
              <validation-provider
                #default="{ errors }"
                name="motivo"
                rules="required"
              >
                <b-form-group
                  label="Motivo da Alteração"
                  label-for="v-motivo"
                >
                  <b-form-input
                    id="v-motivo"
                    v-model="FaixaContribuicaoPlace.motivo"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Ex: Mudança de categoria por idade"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- situacaoRegistro -->
            <b-col
              ols="12"
              lg="12"
            >
              <b-form-group
                label="Categoria de Contribuição"
                label-for="v-tipo-faixa"
              >
                <v-select
                  v-model="FaixaContribuicaoPlace.tipoFaixa"
                  :disabled="disableForm"
                  label="nome"
                  :options="comboTipoFaixa"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="false"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'
import { VueGoodTable } from 'vue-good-table'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    VueGoodTable,
    BBadge,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('combosModule', {
      comboTipoFaixa: state => state.comboTipoFaixa,
    }),
    ...mapState('aggregatesAdministrativeModule', {
      fullAggregate: state => state.fullAggregate,
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    canInsert() {
      return this.verificarPermissao('ROLE_FAIXA_CONTRIBUICAO_INSERIR')
    },
  },
  mounted() {
    this.getHistoricoFaixaContribuicao()
    this.faixaAtual = this.fullAggregate.tipoFaixa
      ? this.fullAggregate.tipoFaixa.nome
      : 'Nenhuma'
    this.$store.dispatch('combosModule/loadComboFaixaContribuicao')
  },
  methods: {
    getHistoricoFaixaContribuicao() {
      this.$store
        .dispatch(
          'aggregatesAdministrativeModule/getHistoricoFaixaContribuicao',
          this.$route.params.id,
        )
        .then(response => {
          this.listaHistorico = response.data
        })
    },
    inserirHistorico() {
      this.FaixaContribuicaoPlace = {
        motivo: '',
        dataInicio: new Date().toISOString().split('T')[0],
        registro: {
          id: null,
        },
        tipoFaixa: {
          id: null,
        },
      }
      this.FaixaContribuicaoPlace.registro.id = this.$route.params.id
      this.disableForm = false
    },
    cancel() {
      this.FaixaContribuicaoPlace = {
        motivo: '',
        dataInicio: null,
        registro: {
          id: null,
        },
        tipoFaixa: {
          id: null,
        },
      }
      this.disableForm = true
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$store
            .dispatch(
              'aggregatesAdministrativeModule/setMudarFaixaContribuicao',
              this.FaixaContribuicaoPlace,
            )
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  'Falha ao Editar',
                  response.response.data.error,
                )
                return
              }
              if (response.error) {
                this.MensagemError('Falha ao Editar', response.message)
                return
              }
              this.showMessageSuccess('Editar', 'Editado com sucesso!')
              this.faixaAtual = response.data.tipoFaixa.nome
              this.FaixaContribuicaoPlace.tipoFaixa = response.data.tipoFaixa
              this.getHistoricoFaixaContribuicao()
              this.disableForm = true
            })
        }
      })
    },
    fieldFn(rowObj) {
      if (!rowObj.dataInicio) return '-'
      const parts = rowObj.dataInicio.split('-')
      return `${parts[2]}/${parts[1]}/${parts[0]}`
    },
    fieldFimFn(rowObj) {
      if (!rowObj.dataFim) return 'Atual'
      const parts = rowObj.dataFim.split('-')
      return `${parts[2]}/${parts[1]}/${parts[0]}`
    },
  },
  data() {
    return {
      faixaAtual: null,
      listaHistorico: [],
      required,
      disableForm: true,
      FaixaContribuicaoPlace: {
        motivo: '',
        dataInicio: null,
        registro: {
          id: null,
        },
        tipoFaixa: {
          id: null,
        },
      },
      columns: [
        {
          label: 'Categoria de Contribuição',
          field: 'tipoFaixa.nome',
        },
        {
          label: 'Início',
          field: this.fieldFn,
        },
        {
          label: 'Fim',
          field: this.fieldFimFn,
        },
        {
          label: 'Motivo',
          field: 'motivo',
        },
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc',
      },
      pageLength: 10,
      dir: false,
    }
  },
}
</script>
